// Generate a unique ID for the event
const generateEventId = () => {
  const timestamp = new Date().getTime();
  const random = Math.random().toString(36).substring(2, 9);
  return `${timestamp}-${random}@scheduler.app`;
};

// Format date to iCal format (YYYYMMDDTHHMMSS)
const formatDateToICal = (dateString) => {
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  
  return `${year}${month}${day}T${hours}${minutes}${seconds}`;
};

// Generate iCal content for the appointment
export const generateICal = (schedule) => {
  const startDate = formatDateToICal(schedule.appointment_naive);
  // Assume 1 hour appointment duration if not specified
  const endDate = formatDateToICal(
    new Date(new Date(schedule.appointment_naive).getTime() + 60 * 60 * 1000).toISOString()
  );
  
  const eventId = generateEventId();
  const timestamp = formatDateToICal(new Date().toISOString());
  
  const icalContent = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//Scheduler App//EN',
    'CALSCALE:GREGORIAN',
    'METHOD:PUBLISH',
    'BEGIN:VEVENT',
    `UID:${eventId}`,
    `DTSTAMP:${timestamp}`,
    `DTSTART:${startDate}`,
    `DTEND:${endDate}`,
    `SUMMARY:${schedule.type || 'Appointment'}`,
    `LOCATION:${schedule.location_name || ''}`,
    `DESCRIPTION:Services: ${schedule.type || 'Appointment'}\\n` +
      (schedule.possession_summary
        ? `${schedule.possession_label || 'Details'}: ${schedule.possession_summary}\\n`
        : ''),
    'STATUS:CONFIRMED',
    'END:VEVENT',
    'END:VCALENDAR'
  ].join('\r\n');
  
  return icalContent;
};

// Download iCal file
export const downloadICal = (schedule) => {
  const icalContent = generateICal(schedule);
  const blob = new Blob([icalContent], { type: 'text/calendar;charset=utf-8' });
  const url = window.URL.createObjectURL(blob);
  
  const link = document.createElement('a');
  link.href = url;
  link.download = `appointment-${schedule.id || 'booking'}.ics`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  
  // Clean up the URL object
  window.URL.revokeObjectURL(url);
};